<template>
	<div class="full-width pa-4">
		<h5 class="headline mb-5">{{ title }}</h5>
		<v-form ref="form">
			<v-layout>
				<v-flex xs12 sm12 md4 lg3>
					<v-text-field
						label="Enter Notification Title"
						v-model="notificationTitle"
						clearable
					></v-text-field>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex xs11 sm6 lg3>
					<v-text-field
						label="Enter Notification Message"
						v-model="notificationMessage"
						clearable
					></v-text-field>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex class="mt-4" xs11 sm6 lg3>
					<v-btn
						:loading="sendNotificationLoading"
						color="primary"
						@click="sendNotification"
						>SEND</v-btn
					>
				</v-flex>
			</v-layout>
		</v-form>
	</div>
</template>

<script>
import { SEND_NOTIFICATION, SHOW_ALERT } from "@/store/action-types";

export default {
	name: "SendNotification",
	props: ["title", "themeInputColor"],
	data() {
		return {
			notificationTitle: "",
			notificationMessage: "",
			sendNotificationLoading: false,
			requiredRule: v => !!v || "This is required"
		};
	},
	methods: {
		isFormCorrect() {
			if (!this.notificationMessage || !this.notificationTitle) {
				return false;
			}
			return true;
		},
		dispatchSendNotification() {
			return this.$store
				.dispatch(SEND_NOTIFICATION.dispatch, {
					notificationType: "notification",
					title: this.notificationTitle,
					messageString: this.notificationMessage
				})
				.then(() => {
					this.resetData();
					return;
				})
				.catch(err => {
					throw new Error(err);
				});
		},
		sendNotification() {
			if (!this.isFormCorrect()) {
				this.showAlert("INCORRECT DETAILS");
				return;
			}
			if (!this.sendNotificationLoading) {
				this.sendNotificationLoading = true;
				this.dispatchSendNotification()
					.catch(() => {})
					.finally(() => {
						this.sendNotificationLoading = false;
					});
			}
		},
		showAlert(payload) {
			this.$store.dispatch(SHOW_ALERT.dispatch, { text: payload });
		},
		resetData() {
			this.notificationTitle = null;
			this.notificationMessage = null;
			this.$refs.form.resetValidation();
		}
	}
};
</script>
